import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as utils from "../../../utils.js";

export default class VistaPersonaContactoHermana extends Component {
  render() {
    let VistaDatoFamiliares =
      this.props.DatosMonja.sister && this.props.DatosMonja.sister.fatherName ? (
        <Container>
          <Container className="mb-3">
            <Row>
              <Col lg="3" className="border">
                <h6>Nombre del Padre</h6>
                <p>{this.props.DatosMonja.sister.fatherName}</p>
              </Col>

              <Col lg="3" className="border">
                <h6>Apellidos del Padre</h6>
                <p>{this.props.DatosMonja.sister.fatherSurname}</p>
              </Col>

              <Col lg="3" className="border">
                <h6>País de Nacimiento</h6>
                <p>{this.props.DatosMonja.sister.fatherCountry}</p>
              </Col>
              <Col lg="3" className="border">
                <h6>Provincia de Nacimiento</h6>
                <p>{this.props.DatosMonja.sister.fatherProvince}</p>
              </Col>
            </Row>
            <Row>
              <Col lg="4" className="border">
                <h6>Ciudad o localidad de Nacimiento</h6>
                <p>{this.props.DatosMonja.sister.fatherAddress}</p>
              </Col>
              <Col lg="4" className="border">
                <h6>Fecha de Nacimiento</h6>
                <p>{utils.formatDate(this.props.DatosMonja.sister.fatherBirthdate)}</p>
              </Col>
              <Col lg="4" className="border">
                <h6>¿Padre difunto?</h6>
                <p>{this.props.DatosMonja.sister.fatherAlive === 'Si' ? 'No' : this.props.DatosMonja.sister.fatherAlive === 'No' ? 'Si' :''}</p>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col lg="3" className="border">
                <h6>Nombre de la Madre</h6>
                <p>{this.props.DatosMonja.sister.motherName}</p>
              </Col>
              <Col lg="3" className="border">
                <h6>Apellidos de la Madre</h6>
                <p>{this.props.DatosMonja.sister.motherSurname}</p>
              </Col>
              <Col lg="3" className="border">
                <h6>País de Nacimiento</h6>
                <p>{this.props.DatosMonja.sister.motherCountry}</p>
              </Col>
              <Col lg="3" className="border">
                <h6>Provincia de Nacimiento</h6>
                <p>{this.props.DatosMonja.sister.motherProvince}</p>
              </Col>
            </Row>
            <Row>
              <Col lg="4" className="border">
                <h6>Ciudad o localidad de Nacimiento</h6>
                <p>{this.props.DatosMonja.sister.motherAddress}</p>
              </Col>
              <Col lg="4" className="border">
                <h6>Fecha de Nacimiento</h6>
                <p>{utils.formatDate(this.props.DatosMonja.sister.motherBirthdate)}</p>
              </Col>
              <Col lg="4" className="border">
                <h6>¿Madre difunta?</h6>
                <p>{this.props.DatosMonja.sister.motherAlive === 'Si' ? 'No' : this.props.DatosMonja.sister.motherAlive === 'No' ? 'Si' :''} </p>
              </Col>
            </Row>
          </Container>
        </Container>
      ) : (
        <p className="ml-3">No hay datos actualmente</p>
      );
    return <React.Fragment>{VistaDatoFamiliares}</React.Fragment>;
  }
}
